import React from "react";
import { useBrowserPageTitle } from "../../shared/hooks/useBrowserPageTitle";
import { Redirect, Route, Switch } from "react-router-dom";
import { RouteRequirements } from "./routes/RouteRequirements";
import { RouteRequirementDetails } from "./routes/RouteRequirementDetails";
import { RouteCreateRequirementByTemplate } from "./routes/RouteCreateRequirementByTemplate";
import { RouteCreateRequirementFlow } from "./routes/RouteCreateRequirementByTemplate/CreateRequirementFlow";
import {
  ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_FLOW_PATH,
  ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_SELECT_PATH,
  ENGAGEMENT_REQUIREMENTS_DETAILS_PATH,
  ENGAGEMENT_REQUIREMENTS_SECTION_PATHS
} from "./paths/constants";

export const EngagementRequirementsIndex: React.FC = () => {
  useBrowserPageTitle("Engagement requirements");

  return (
    <Switch>
      <Route
        path={ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_FLOW_PATH}
        component={RouteCreateRequirementFlow}
      />

      <Route
        path={ENGAGEMENT_REQUIREMENTS_CREATE_BY_TEMPLATE_SELECT_PATH}
        component={RouteCreateRequirementByTemplate}
        exact
      />

      <Route
        path={ENGAGEMENT_REQUIREMENTS_SECTION_PATHS}
        component={RouteRequirements}
      />
      <Route
        path={ENGAGEMENT_REQUIREMENTS_DETAILS_PATH}
        component={RouteRequirementDetails}
      />
      <Redirect from="*" to={ENGAGEMENT_REQUIREMENTS_SECTION_PATHS[0]} />
    </Switch>
  );
};
